// extracted by mini-css-extract-plugin
export default {"wrapper":"modal_wrapper__BXrY4","content":"modal_content__xn9NH"};